import {
  LoginActionConst,
  SignUpActionConst,
  ClearSignUpFieldsActionConst,
  GetLandlordProfileActionConst,
  LogoutActionConst,
  ForgotPasswordUserIdActionConst,
  HydrateStateActionConst,
} from "../../constants/authActionConst";
import BaseUrl from "../../../constants/BaseUrl";
import { getStorageItem, clearAuthStorage } from "../../../utils/storageUtils";

export const HydrateStateAction = () => {
  return async (dispatch) => {
    try {
      const loginSuccess = getStorageItem("loginSuccess");
      const userCredentials = getStorageItem("userCredentials");

      dispatch({
        type: HydrateStateActionConst.HYDRATE_STATE_FROM_STORAGE,
        payload: {
          loginSuccess,
          userCredentials,
        },
      });

      // If we have login success data, also fetch the latest profile
      if (loginSuccess?.user?._id && loginSuccess?.token) {
        dispatch(GetLandlordProfile(loginSuccess.user._id, loginSuccess.token));
      }
    } catch (error) {
      console.error("Error hydrating state from localStorage:", error);
      clearAuthStorage();
    }
  };
};

export const UserLogInAction = (fields) => {
  return async (dispatch) => {
    dispatch({
      type: LoginActionConst.USER_LOGIN_REQUEST,
    });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      email: fields.email,
      password: fields.password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/auth/signIn`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: LoginActionConst.USER_LOGIN_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: LoginActionConst.USER_LOGIN_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const ClearSignUpFieldsAction = () => {
  return async (dispatch) => {
    dispatch({
      type: ClearSignUpFieldsActionConst.SIGNUP_CLEAR,
    });
  };
};

export const LogoutAction = () => {
  return async (dispatch) => {
    clearAuthStorage();

    dispatch({
      type: LogoutActionConst.LOGOUT_ACTION,
    });
  };
};

export const GetLandlordProfile = (userId, token) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  return async (dispatch) => {
    dispatch({
      type: GetLandlordProfileActionConst.GET_USER_PROFILE_REQ,
    });

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}landlord/profile/getProfileDetails/${userId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: GetLandlordProfileActionConst.GET_USER_PROFILE_SUCCESS,
            result: result.data,
          });
        } else {
          // alert("ERROR=", JSON.stringify(result))
          dispatch({
            type: GetLandlordProfileActionConst.GET_USER_PROFILE_FAIL,
            result: result.message,
          });
        }
      })
      .catch((error) => console.error(error));

    return;
  };
};

export const UserSignUpAction = (fields) => {
  return async (dispatch) => {
    dispatch({
      type: SignUpActionConst.USER_SIGNUP_REQUEST,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      firstName: fields.firstName,
      lastName: fields.lastName,
      email: fields.email,
      password: fields.password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/auth/signUp`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: SignUpActionConst.USER_SIGNUP_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: SignUpActionConst.USER_SIGNUP_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const ForgotPasswordUserIdAction = (id) => {
  return async (dispatch) => {
    dispatch({
      type: ForgotPasswordUserIdActionConst.FORGOT_PASS_USER_ID,
      id: id,
    });
  };
};

export const ClearForgotPasswordUserIdAction = (id) => {
  return async (dispatch) => {
    dispatch({
      type: ForgotPasswordUserIdActionConst.CLEAR_USER_ID,
    });
  };
};
